module.exports = __webpack_public_path__ + "static/img/2_1_1.62b65e0b.jpg";